<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="780px"
    >
        <v-card style="height: 100% !important;" flat>
            <v-card-title style="align-items: flex-start; flex-direction: column">
                <div>{{ indicator.group_code }}</div>
                <div>{{ indicator.indicator_type_code }} - {{indicator.indicator_type_name}}</div>
<!--                <v-text-field class='input-text input-text&#45;&#45;text-field pl-1' hide-details="auto" outlined dense v-model="indicator.indicator_type_name"/>-->
            </v-card-title>
            <v-card-text style="padding-bottom: 0">
                <v-sparkline
                    :value="sparkValues"
                    line-width="2"
                    padding="14"
                    padding-bottom="8"
                    fill
                    smooth
                    color="hsla(201, 100%, 41%, 1)"
                ></v-sparkline>
            </v-card-text>
            <v-card-text class="py-0">
                <v-data-table
                    :headers="headers"
                    :items="indicatorToTable"
                    disable-sort
                    class="table"
                    auto-line-width
                    hide-default-footer
                    >
                        <template #no-data>
                            <span>{{ $t('indicators.indicators_list.no_records_found') }}</span>
                        </template>
                        <template #item.actions="{ item }">
                            <v-btn
                                    class='btn-icon--primary btn-icon'
                                    @click='editIndicator(item)'
                                ><v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                </v-data-table>
            </v-card-text>
            <v-card-text style="display:flex; flex-wrap: wrap; flex-direction: column; gap: 8px" class="align-center py-4">
                {{ `${$t('indicators.indicators_editing.new_indicator_value')} ${currentPeriod}` }}:
                <div style="max-width: 100px;">
                    <v-text-field class='input-text input-text--text-field' hide-details="auto" @input="onEditing" outlined dense v-model="editingIndicator.total" type="number" :min="0" :rules="[rules.required, rules.min, rules.max]"/>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
<!--                    <v-btn-->
<!--                        class="v-btn&#45;&#45;primary"-->
<!--                        disabled="confirmDisabled"-->
<!--                        text-->
<!--                        @click="confirmUpdate"-->
<!--                    >{{ $t('app.save') }}</v-btn>-->

                <v-btn
                    class="v-btn--primary"
                    :disabled="isDisabled"
                    text
                    @click="confirmUpdate"
                >{{ $t('app.save') }}</v-btn>

                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="onCancelEdit"
                    >{{ $t('app.cancel') }}</v-btn>
                </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {IndicatorsStore} from "@/Store/Indicators/IndicatorsStore";
import {mapState, mapActions} from "pinia";
import _ from "lodash";
import {i18n} from "@/i18n";

export default {
    name: "EditingDialog",

    data: () => ({
        temporaryData: null,
        isDisabled: false,
        rules: {
            required: value => !!value || i18n.t('indicators.indicators_editing.error.required'),
            min: value => (value && value >= 0) || i18n.t('indicators.indicators_editing.error.only_positive_number'),
            max: value => (value && value.toString().length <= 10) || i18n.t('indicators.indicators_editing.error.maximun_ten_digits'),
        },
    }),

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        indicator: {
            type: Object,
            required: true
        },
        headers: [],
    },

    computed: {
        indicatorToTable() {
            return [this.indicator]
        },
        editingIndicator() {
            return this.indicator
        },
        ...mapState(IndicatorsStore, ['indicatorToCustomize']),
        sparkValues() {
          return this.indicator.values;
        },
        currentPeriod() {
            if (this.headers[0]) {
                return this.headers[0].text;
            }
            return "";
        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmUpdate() {
            this.customize();
             this.$emit('confirmCustomizeIndicator');
             this.closeDialog();
             this.temporaryData = null;
        },

        /**
         * Closes the deletion dialog
         */
        closeDialog() {
            this.$emit('cancelEditingDialog')
        },

        ...mapActions(IndicatorsStore, [
            'customize', 'setIndicatorToCustomize',
        ]),

        mapItems(object){
            let result = [];
            for (const [key, value] of Object.entries(object)) {
                let entries  = Object.entries(value)
                let item = [];
                for (const [key_, value_] of entries) {
                    item[key_] = value_;
                }
                result.push(Object.assign({}, item));
            }
            return result;
        },

        onEditing(value) {
            const finalYear = this.indicator.final_year;
            if (this.temporaryData == null) {
                this.temporaryData = this.indicator[finalYear];
            }
            this.indicator[finalYear] = parseFloat(value);
            this.indicator.values.splice(0, 1, parseFloat(value));
        },

        onCancelEdit() {
            if (this.temporaryData != null) {
                this.indicator[this.indicator.final_year] = this.temporaryData;
                this.indicator.values.splice(0, 1, this.temporaryData);
                this.temporaryData = null;
            }

            this.closeDialog();
        },

        // Validate edit data and customize indicator
        isValidData(){
            const value = this.editingIndicator.total;
            this.isDisabled = !(value && value >= 0 && value.toString().length <= 10);
        },
    },

    watch: {
        'editingIndicator.total': {
            handler() {
                this.setIndicatorToCustomize(this.editingIndicator);

                //Method in watch section to get data and validate edit
                this.isValidData();
            },
        }
    },
}
</script>

<style scoped>

</style>
